// Angular imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import components
import { OpenProjectComponent } from './open-project/open-project.component';
import { MenuComponent } from './menu/menu.component';

const routes: Routes = [
    { path: '', component: OpenProjectComponent },
    { path: 'project/:projectId/calc/:calcId', component: MenuComponent },
    { path: '**', redirectTo: '/' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
